import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, withInterceptors, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Firebase and AngularFire imports
import { provideAuth, getAuth } from '@angular/fire/auth';
import { FirebaseApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';

// Icons and Scrollbars
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { NgScrollbarModule } from 'ngx-scrollbar';

// Material and Forms
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Layouts and Pipes
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { FilterPipe } from './pipe/filter.pipe';

// Translate loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Interceptor for auth
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { firebaseConfig } from './firebaseConfig';

export function HttpLoaderFactory(http: HttpClient): any {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import { TensorflowTestComponent } from './components/tensorflow-test/tensorflow-test.component';
import { YoloDetectorComponent } from './components/yolo-detector/yolo-detector.component';
import { TranslatedPaginatorIntl } from 'src/assets/i18n/translated-paginator-intl';
import { MatPaginatorIntl } from '@angular/material/paginator';

@NgModule({
    declarations: [
        AppComponent,
        BlankComponent,
        FilterPipe,
        TensorflowTestComponent,
        YoloDetectorComponent,
    ],
    exports: [TablerIconsModule, TranslateModule],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        TablerIconsModule.pick(TablerIcons),
        NgScrollbarModule,
        TranslateModule.forRoot({
            useDefaultLang: true,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        FullComponent], providers: [
            provideFirebaseApp(() => initializeApp(firebaseConfig)),
            provideAuth(() => getAuth()),
            provideFirestore(() => getFirestore()),
            {
                provide: HTTP_INTERCEPTORS,
                useClass: AuthInterceptor,
                multi: true,
            },
            provideHttpClient(withInterceptorsFromDi()),
            {
                provide: MatPaginatorIntl,
                useClass: TranslatedPaginatorIntl
            }
        ]
})
export class AppModule { }
